<template>
  <app-page :labelledby="pageState ? '' : 'transfer-template-edit-title'">
    <app-state
      v-if="pageState"
      :state="pageState"
      :title="stateTitle"
      :message="pageMessage"
      :action-label="pageState === 'not-found' ? 'Вернуться к шаблонам' : 'Повторить'"
      :action-to="pageState === 'not-found' ? { name: 'transfer_templates_list' } : null"
      @retry="load"
    />
    <transfer-template-editor
      v-else
      mode="edit"
      :bills="bills"
      :initial-value="template"
      :save-state="saveState"
      :save-error="saveError"
      @cancel="$router.push({ name: 'transfer_templates_list' })"
      @save="saveTemplate"
    />
  </app-page>
</template>

<script>
import AppPage from '../../../components/ui/AppPage.vue'
import AppState from '../../../components/ui/AppState.vue'
import { normalizeCompactBillsResponse } from '../../../services/financeCore'
import { validateStoredTemplate } from '../../../services/transferWorkspace'
import TransferTemplateEditor from './TransferTemplateEditor.vue'

export default {
  name: 'transfer_templates_edit',
  components: { AppPage, AppState, TransferTemplateEditor },
  data() {
    return {
      bills: [],
      template: null,
      loadingBills: true,
      loadingTemplate: true,
      errorState: '',
      error: '',
      saveState: 'idle',
      saveError: '',
      handlers: []
    }
  },
  computed: {
    pageState() {
      if (this.loadingBills || this.loadingTemplate) return 'loading'
      if (this.errorState) return this.errorState
      return ''
    },
    stateTitle() {
      if (this.pageState === 'loading') return 'Загружаем шаблон'
      if (this.pageState === 'not-found') return 'Шаблон не найден'
      return 'Не удалось загрузить шаблон'
    },
    pageMessage() {
      return this.error || 'Подготавливаем шаблон и список счетов.'
    }
  },
  mounted() {
    this.listen('didReceiveBillListFlatCompact', this.onBills)
    this.listen('onGetTransferTemplate', this.onTemplate)
    this.listen('onTransferTemplateError', this.onTemplateError)
    this.listen('onUpdateTransferTemplate', this.onSaved)
    this.listen('connectionReady', this.load)
    if (this.connection.isAuthenticated) this.load()
  },
  beforeUnmount() {
    this.handlers.forEach(([event, handler]) => this.emitter.off(event, handler))
  },
  methods: {
    listen(event, handler) {
      this.emitter.on(event, handler)
      this.handlers.push([event, handler])
    },
    load() {
      this.loadingBills = true
      this.loadingTemplate = true
      this.errorState = ''
      this.error = ''
      this.connection.gitBillsListFlatCompact('transfer-template-edit-bills')
      this.connection.getTransferTemplate('transfer-template-edit-load', this.$route.params.id)
    },
    onBills(response) {
      const normalized = normalizeCompactBillsResponse(response)
      this.loadingBills = false
      if (!normalized.ok) {
        this.errorState = normalized.state || 'error'
        this.error = normalized.message
        return
      }
      this.bills = normalized.bills
    },
    onTemplate(response) {
      this.loadingTemplate = false
      const normalized = validateStoredTemplate(response.template)
      if (!normalized.ok) {
        this.errorState = normalized.state
        this.error = normalized.message
        return
      }
      this.template = normalized.model
    },
    onTemplateError(error) {
      this.loadingTemplate = false
      this.errorState = error.state || 'error'
      this.error = error.message || 'Не удалось загрузить шаблон проводки'
    },
    saveTemplate(payload) {
      if (this.saveState === 'saving') return
      this.saveState = 'saving'
      this.saveError = ''
      this.connection.updateTransferTemplate(
        'transfer-template-edit-save',
        this.$route.params.id,
        payload
      )
    },
    onSaved(response) {
      if (response.type === 'error' || response.error) {
        this.saveState = 'error'
        this.saveError = response.message || 'Не удалось сохранить шаблон'
        return
      }
      this.saveState = 'saved'
      this.$router.push({ name: 'transfer_templates_list' })
    }
  }
}
</script>
